import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { UnauthorizedPageComponent } from './pages/unauthorized-page/unauthorized-page.component';
import { AuthCallbackPageComponent } from './pages/auth-callback-page/auth-callback-page.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { DeepLinkingPageComponent } from './pages/deeplinking-page/deeplinking-page.component';
import { AuthGuard } from './auth.guard';
import { RoleGuard } from './role.guard';
import { DashboardGuard } from './dashboard.guard';
import { AppPreloadingStrategy } from './app-preloading-strategy.module';

const appRoutes: Routes = [
  {
    path: 'landing',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'user/settings',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/user-profile.module').then(m => m.UserProfileModule)
  },
  {
    path: 'customer',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/customer.module').then(m => m.CustomerModule)
  },
  {
    path: 'resi',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/resi.module').then(m => m.ResiModule),
    data: { preload: true }
  },
  {
    path: 'sale',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/sale.module').then(m => m.SaleModule),
    data: { preload: true }
  },
  {
    path: 'lease',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/lease.module').then(m => m.LeaseModule)
  },
  {
    path: 'consulting',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/consulting.module').then(m => m.ConsultingModule)
  },
  {
    path: 'dsf',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/dsf.module').then(m => m.DsfModule)
  },
  {
    path: 'disbursement',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/expense.module').then(m => m.ExpenseModule)
  },
  {
    path: 'valuation',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/valuation.module').then(m => m.ValuationModule)
  },
  {
    path: 'non-financial',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/nonfinancial.module').then(m => m.NonFinancialModule)
  },
  {
    path: 'transaction-summary',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/transaction-summary.module').then(m => m.TransactionSummaryModule)
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard, RoleGuard, DashboardGuard],
    loadChildren: () => import('./modules/features/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'review',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/review.module').then(m => m.ReviewModule)
  },
  {
    path: 'help',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./modules/features/help.module').then(m => m.HelpModule)
  },
  {
    path: 'reports',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () => import('./pages/reports-page/reports.module').then(m => m.ReportsModule)
  },
  { path: '', pathMatch: 'full', component: HomePageComponent },
  { path: 'adfs-callback', component: AuthCallbackPageComponent },
  { path: 'unauthorized', component: UnauthorizedPageComponent },
  {
    path: 'deeplinking',
    canActivate: [AuthGuard, RoleGuard],
    component: DeepLinkingPageComponent
  },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { preloadingStrategy: AppPreloadingStrategy, onSameUrlNavigation: 'reload' }
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AppPreloadingStrategy
  ]
})
export class AppRoutingModule { }
